/**
 * Labstep
 *
 * @module components/ResearchArea/Item
 * @desc ResearchArea Item
 */

import { EntityToggleContainer } from 'labstep-web/containers/Entity/Toggle';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type {
  IResearchAreaItemProps,
  IResearchAreaItemToggleContainerProps,
} from './types';

const ResearchAreaItem: React.FC<IResearchAreaItemProps> = ({
  researchArea,
  onRemoveClick,
  status,
}) => (
  <RemoveLabel
    name={researchArea.label}
    onRemoveClick={onRemoveClick}
    status={status}
  />
);

export const ResearchAreaItemToggleContainer: React.FC<
  IResearchAreaItemToggleContainerProps
> = ({ profile, researchArea, remove }) => (
  <EntityToggleContainer
    action="remove"
    entityIds={researchArea.id}
    entityName="research_area"
    parentName="profile"
    parentId={profile.id}
  >
    {({ toggle, status }) => (
      <ResearchAreaItem
        onRemoveClick={remove ? () => toggle() : undefined}
        researchArea={researchArea}
        status={status}
      />
    )}
  </EntityToggleContainer>
);
